module.exports = __webpack_public_path__ + "media/images/landing_page/main_phone-4d5f8a4b9ce7f865af4df5a610248a51.png";